<template>
  <div :id="id" v-click-outside="closeFilter" class="app-data-filter" :aria-labelledby="`${id}Toggler`">
    <div class="app-data-filter__go-back">
      <button class="app-data-filter__button app-data-filter__go-back-btn" aria-label="Close" @click="closeFilter">
        <AppGoBackIcon class="app-data-filter__go-back-btn-icon" />
      </button>
    </div>
    <div class="app-data-filter__header">
      <span class="app-data-filter__header-label">Filters</span>
      <button class="app-data-filter__button app-data-filter__btn-close" aria-label="Close" @click="closeFilter">
        <AppCrossIcon class="app-data-filter__btn-close-icon" />
      </button>
    </div>

    <div class="app-data-filter__body">
      <template v-for="group in filterGroups">
        <AppDataFilterCheckboxGroup
          v-if="group.type === 'checkbox'"
          :key="group.itemsType"
          :group="group"
          :toggler="checkboxGroupToggles[group.itemsType] || false"
          :value="value[group.itemsType]"
          @toggle="onToggleGroup"
          @update="updateValues($event, group.itemsType, group.type)"
        />
        <AppDataFilterRadioGroup
          v-else-if="group.type === 'radio'"
          :key="group.itemsType"
          :group="group"
          :value="value[group.itemsType]"
          @update="updateValues($event, group.itemsType, group.type)"
        />
        <AppDataFilterInputRangeGroup
          v-else-if="group.type === 'range'"
          :key="group.itemsType"
          :group="group"
          :value="value[group.itemsType] || undefined"
          :toggler="checkboxGroupToggles[group.itemsType] || false"
          @toggle="onToggleGroup"
          @update="updateValues($event, group.itemsType, group.type)"
        />
      </template>
    </div>

    <div>
      <slot name="bottom-content" />
    </div>
  </div>
</template>

<script>
import AppCrossIcon from '@/components/icons/AppCrossIcon';
import AppGoBackIcon from '@/components/icons/AppGoBackIcon';
import AppDataFilterCheckboxGroup from './AppDataFilterCheckboxGroup';
import AppDataFilterRadioGroup from './AppDataFilterRadioGroup';
import AppDataFilterInputRangeGroup from '@/components/data-filter/AppDataFilterInputRangeGroup.vue';

export default {
  name: 'AppDataFilter',
  components: {
    AppDataFilterInputRangeGroup,
    AppCrossIcon,
    AppGoBackIcon,
    AppDataFilterCheckboxGroup,
    AppDataFilterRadioGroup,
  },
  props: {
    filterGroups: {
      type: Array,
      required: true,
    },
    id: {
      type: String,
      default: 'dataFilter',
    },
    isOpened: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      activeCheckboxGroup: {
        itemsType: null,
        opened: false,
      },
    };
  },

  computed: {
    checkboxGroupToggles: {
      get() {
        return this.filterGroups.reduce((toggles, group) => {
          if (group.type !== 'checkbox') {
            return toggles;
          }

          let opened;
          if (this.activeCheckboxGroup.itemsType !== null) {
            opened = group.itemsType === this.activeCheckboxGroup.itemsType ? this.activeCheckboxGroup.opened : false;
          } else {
            opened = this.filterGroups.length === 1;
          }

          return { ...toggles, [group.itemsType]: opened };
        }, {});
      },
      set({ itemsType, opened }) {
        this.activeCheckboxGroup.itemsType = itemsType;
        this.activeCheckboxGroup.opened = opened;
      },
    },
  },

  methods: {
    closeFilter() {
      this.$emit('close');
    },
    onToggleGroup({ itemsType, opened }) {
      this.checkboxGroupToggles = { itemsType, opened };
    },
    updateValues(values, itemsType, type) {
      if (type === 'radio') {
        this.onToggleGroup({ itemsType: '' });
      }
      this.$emit('update', { itemsType, values });
    },
  },
};
</script>
